import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Incident } from '../model/incident.model';
import { ApiCommunicationService } from './api-communication.service';
import { DivisionsContainer } from '../model/divisions-container.model';
import { DamageTypesContainerModel } from '../model/damage-types-container.model';
import { DamageReasonsContainerModel } from '../model/damage-reasons-container.model';
import { HeaderType } from '../model/header-type.enum';
import { AddressesContainerModel } from '../model/addresses-container.model';
import { LocationsContainerModel } from '../model/locations-container.model';
import { IncidentHelper } from '../model/incident-helper.model';

@Injectable({
  providedIn: 'root',
})

export class IncidentsService {

  private createModeNotifier$: Subject<number> = new Subject<number>();
  private createFromReportModeNotifier$: Subject<Partial<Incident>> = new Subject<Partial<Incident>>();
  private editModeNotifier$: Subject<string> = new Subject<string>();
  private editIncidentFromReportModeNotifier$: Subject<IncidentHelper> = new Subject<IncidentHelper>();
  private refreshGridNotifier$: Subject<boolean> = new Subject<boolean>();

  constructor(private apiCommunicationService: ApiCommunicationService) {
  }

  createIncident(module: number): Observable<Incident> {
    return this.apiCommunicationService.createNewIncidentOrReport(HeaderType.INCIDENTS, module);
  }

  editIncident(rowKey: string): Observable<Incident> {
    return this.apiCommunicationService.getExistingIncidentOrReport(HeaderType.INCIDENTS, rowKey);
  }

  getIncidentBySTMID(stmid: string): Observable<Incident> {
    return this.apiCommunicationService.getExistingIncidentOrReportBySTMID(HeaderType.INCIDENTS, stmid);
  }

  saveIncident(model: Partial<Incident>): Observable<Incident> {
    return this.apiCommunicationService.saveIncidentOrReport(model);
  }

  cancelIncident(stmid: string): Observable<boolean> {
    return this.apiCommunicationService.cancelIncidentOrReport(stmid);
  }

  createReference(parentRowKey: string, childRowKey: string): Observable<boolean> {
    return this.apiCommunicationService.createReference(parentRowKey, childRowKey);
  }

  createIncidentNotify(division: number): void {
    this.createModeNotifier$.next(division);
  }

  getCreateModeNotification(): Observable<number> {
    return this.createModeNotifier$.asObservable();
  }

  createIncidentFromReportNotify(report: Partial<Incident>): void {
    this.createFromReportModeNotifier$.next(report);
  }

  getCreateFromReportModeNotification(): Observable<Partial<Incident>> {
    return this.createFromReportModeNotifier$.asObservable();
  }

  editIncidentNotify(rowKey: string): void {
    this.editModeNotifier$.next(rowKey);
  }

  getEditModeNotification(): Observable<string> {
    return this.editModeNotifier$.asObservable();
  }

  editIncidentFromReportNotify(incidentValues: IncidentHelper): void {
    this.editIncidentFromReportModeNotifier$.next(incidentValues);
  }

  getEditIncidentFromReportModeNotification(): Observable<IncidentHelper> {
    return this.editIncidentFromReportModeNotifier$.asObservable();
  }

  getDivisions(): Observable<DivisionsContainer> {
    return this.apiCommunicationService.getDivisions();
  }

  getAddresses(): Observable<AddressesContainerModel> {
    return this.apiCommunicationService.getAddresses();
  }

  getLocations(division: number): Observable<LocationsContainerModel> {
    return this.apiCommunicationService.getLocations(division);
  }

  getDamageTypes(module: number): Observable<DamageTypesContainerModel> {
    return this.apiCommunicationService.getDamageTypes(module);
  }

  getDamageReasons(module: number): Observable<DamageReasonsContainerModel> {
    return this.apiCommunicationService.getDamageReasons(module);
  }

  refreshGridNotify(): void {
    this.refreshGridNotifier$.next(true);
  }

  getRefreshGridNotification(): Observable<boolean> {
    return this.refreshGridNotifier$.asObservable();
  }

}
